import React from 'react';
import EvidenceTab from '../EvidenceTab';
import TechnicalTab from '../TechnicalTab';
import GeneralTab from '../GeneralTab';
import CustomFieldsTab from '../CustomFieldsTab';
import CommentTab from '../CommentTab';
import StatusTraceTab from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/StatusTraceTab';

const TABS = [
  {
    id: 'general',
    intlId: 'manage.detail.tab.general',
    component: <GeneralTab />
  },
  {
    id: 'technicalDetails',
    intlId: 'manage.detail.tab.technicalDetails',
    component: <TechnicalTab />
  },
  {
    id: 'evidence',
    intlId: 'manage.detail.tab.evidence',
    component: <EvidenceTab />
  },
  {
    id: 'customFields',
    intlId: 'manage.detail.tab.customAttributes',
    component: <CustomFieldsTab />
  },
  {
    id: 'comment',
    intlId: 'manage.detail.tab.comment',
    component: <CommentTab />
  },
  {
    id: 'statusTrace',
    intlId: 'manage.detail.tab.statusTrace',
    component: <StatusTraceTab entity="manageGeneral.vulnDetail" />
  }
];

export default TABS;
